import { getFontFamily } from '@tmapy/style-guide';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Text from 'ol/style/Text';
const FONT_FAMILY = getFontFamily();
export function getTextStyle({ text, color, geometry, rotation = 0, textAlign = 'left', offsetX = 0, offsetY = 0, placement = 'point', overflow = true, }) {
    return [
        new Style({
            geometry,
            text: getText({
                text,
                rotation,
                textAlign,
                offsetX,
                offsetY,
                placement,
                overflow,
                color,
            }),
        }),
    ];
}
export function getText({ text, color, rotation = 0, textAlign = 'left', offsetX = 0, offsetY = 0, placement = 'point', overflow = true, }) {
    return new Text({
        overflow,
        rotation,
        font: `bold 13px ${FONT_FAMILY}`,
        offsetX,
        offsetY,
        text,
        placement,
        textAlign,
        textBaseline: 'middle',
        fill: new Fill({ color }),
        stroke: new Stroke({
            color: [255, 255, 255],
            width: 3,
        }),
    });
}
//# sourceMappingURL=text.js.map